module.exports = __webpack_public_path__ + "img/coupon_bg_3.b9ed5375.png";